export const searchDropdown = [
	{
	  title: "Custom Shipping String Name",
	  value: "shmShipmentMethod"
	},
	{
	  title: "Shipping Method/Service Level",
	  value: "shmShipmentMethodCode"
	}
]



// WEBPACK FOOTER //
// ./src/pages/shipmentStringMapping/filter/searchDropdown.js